import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {suppliersUnitsStore} from '@store/suppliers/units/suppliers-units.store';

export const getSuppliersUnitsDataSource = createRequestDataSource({
  store: suppliersUnitsStore,
  data$: () => suppliersUnitsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getSuppliersUnits',
  dataKey: 'suppliersUnits',
});